class ProductTemplate extends HTMLElement {
    constructor() {
        super();
        this.firsLoad = true;
        this.init();
        window.addEventListener('resize', this.initSlider.bind(this));
        document.addEventListener('DOMContentLoaded', this.initProductForm.bind(this));
        window.addEventListener('resize', this.changeSticky.bind(this));

        document.querySelector('.product-form-submit-button__bottom').addEventListener('click', () => {
            document.querySelector('.product-form-submit-button').click();
        });

        const productForm = document.querySelector('#product-form');
        const productFormBottom = document.querySelector('.product-form__form-bottom');

        //  if the product form is out of the viewport make it sticky but if the section is under the viewport make it not sticky

        window.addEventListener('scroll', () => {
            const productFormRect = productForm.getBoundingClientRect();
            const productFormBottomRect = productFormBottom.getBoundingClientRect();

            if (productFormRect.top < 0) {
                productFormBottom.classList.add('sticky');
            } else {
                productFormBottom.classList.remove('sticky');
            }

            // if (productFormBottomRect.top > window.innerHeight) {
            //     productFormBottom.classList.remove('sticky');
            // }
        });
    }

    init() {
        this.initSlider();
        this.calculateShipping();
        this.changeSticky();
    }

    changeSticky() {
        let mediaHeight = document.querySelector('.product-media').offsetHeight;
        let formHeight = document.querySelector('.product-form').offsetHeight;

        if (mediaHeight > formHeight) {
            document.querySelector('.product-media').parentNode.classList.add('sticky-form')

        } else {
            document.querySelector('.product-media').parentNode.classList.remove('sticky-form')
        }
    }

    initProductForm() {
        document.querySelectorAll('.product-variant').forEach((variant) => {
            let currentPrice = parseFloat(variant.querySelector('[data-variant-price').dataset.variantPrice.replace(',', '.'));
            if (document.querySelector('#customAbo:checked')) {
                let reduction = document.querySelector('#customAbo:checked').dataset.reduction;
                currentPrice = currentPrice - (currentPrice * (reduction / 100));
            }

            let unitDivider = parseFloat(variant.querySelector('[data-divider-unit]').dataset.dividerUnit);
            let unitUnitDivider = parseFloat(variant.querySelector('[data-divider-unit-unit]').dataset.dividerUnitUnit);
            let pricePerUnit = (currentPrice / unitUnitDivider) / unitDivider;


            variant.querySelector('[price-unit-unit]').innerText = this.roundNumber(pricePerUnit, 3) + '€';
        });
    }

    roundNumber(num, scale) {
        if (!("" + num).includes("e")) {
            return +(Math.round(num + "e+" + scale) + "e-" + scale);
        } else {
            var arr = ("" + num).split("e");
            var sig = ""
            if (+arr[1] + scale > 0) {
                sig = "+";
            }
            return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
    }

    calculateShipping() {
        if (this.querySelector('.product-form__icon')) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(this.querySelector('[data-shipping-delay]').getAttribute('data-shipping-delay'));


            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            for (let i = 0; i < document.querySelectorAll('.product-form__icon').length; i++) {
                let html = document.querySelectorAll('.product-form__icon')[i].innerHTML;
                if (html.indexOf('[date]') > -1) {
                    document.querySelectorAll('.product-form__icon')[i].innerHTML = html.replace('[date]', shipping_date_format);
                }
            }
        }
    }

    initSlider() {
        if (this.firsLoad == true) {
            this.swiperThumb = new Swiper(this.querySelector('.swiper-thumb'), {
                slidesPerView: 'auto',
                direction: 'horizontal',
                centeredSlides: false,
                loopedSlides: this.querySelector('[data-media-size]').dataset.mediaSize,
                loop: false,
                slideToClickedSlide: true,
                autoScrollOffset: 1,
                cssMode: true,
            });

            this.swiper = new Swiper(this.querySelector('.swiper-media'), {
                direction: 'horizontal',
                slidesPerView: 'auto',
                loopedSlides: this.querySelector('[data-media-size]').dataset.mediaSize,
                thumbs: {
                    swiper: this.swiperThumb,
                    slideThumbActiveClass: 'swiper-slide-thumb-active',
                },
                pagination: {
                    el: this.querySelector('.swiper-media .swiper-pagination'),
                }
            });
            this.firsLoad = false;
        }

        if (!document.querySelector('.article-header__container')) {
            if (window.innerWidth < 990) {
                if (document.querySelector('.swiper-media .reassurance__container')) {
                    document.querySelector('.swiper-media .reassurance__container').classList.add('swiper-slide');
                }
                if (this.swiper) {
                    this.swiper.enable();
                }

            } else {
                if (document.querySelector('.swiper-media .reassurance__container')) {
                    document.querySelector('.swiper-media .reassurance__container').classList.remove('swiper-slide');
                }
                if (this.swiper) {
                    this.swiper.slideTo((0, 0, false));
                    this.querySelector('.swiper-media .swiper-wrapper').style = '';
                    this.swiper.disable();
                }
            }
        }

    }
}

customElements.define('product-template', ProductTemplate);

